import { UPDATE_SHOPPINGLIST, CLEAR_SHOPPINGLIST, INIT_SHOPPINGLIST, } from './action-creators';
const shoppingListReducer = (shoppingListState = [], action) => {
    switch (action.type) {
        case UPDATE_SHOPPINGLIST: {
            const shoppingListAction = action;
            const stateCartItems = shoppingListState.filter(i => i.code !== shoppingListAction.code);
            if (shoppingListAction.quantity && shoppingListAction.quantity > 0) {
                stateCartItems.push({
                    code: shoppingListAction.code,
                    quantity: shoppingListAction.quantity,
                    unitShortName: shoppingListAction.unitShortName,
                    ticket: shoppingListAction.ticket,
                });
            }
            return stateCartItems;
        }
        case INIT_SHOPPINGLIST: {
            const shoppingListAction = action;
            return shoppingListAction.shoppingList;
        }
        case CLEAR_SHOPPINGLIST: {
            return [];
        }
        default:
            break;
    }
    return shoppingListState;
};
export default shoppingListReducer;
export const getShoppingList = (state) => state.shoppingList;
